/* Interactions for the copied rack-reference content. Preview timetable retained. */
(() => {
  'use strict';
  if (window.ftReferenceLoaded) return;
  window.ftReferenceLoaded = true;
  const $ = id => document.getElementById(id);
  function delivery(select) {
  const result = select.closest('.delivery-estimator')
    .querySelector('[data-ft-delivery-result]');

  const ranges = {
    '0': [2, 5],
    '1': [3, 6],
    '2': [4, 8],
    '3': [5, 10],
    '4': [7, 15]
  };

  const zone = select.value;
  const range = ranges[zone];

  result.hidden = !range;
  result.replaceChildren();

  if (!range) return;

  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Europe/Berlin',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  }).formatToParts(new Date());

  const get = key => Number(
    parts.find(part => part.type === key).value
  );

  const today = new Date(Date.UTC(
    get('year'), get('month') - 1, get('day'), 12
  ));

  const addWorkingDays = days => {
    const date = new Date(today);

    while (days > 0) {
      date.setUTCDate(date.getUTCDate() + 1);

      if (![0, 6].includes(date.getUTCDay())) {
        days--;
      }
    }

    return date;
  };

  const format = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'UTC',
    day: 'numeric',
    month: 'short'
  });

  const earliest = format.format(addWorkingDays(range[0]));
  const latest = format.format(addWorkingDays(range[1]));

  result.innerHTML = `
    <strong>${earliest} – ${latest}${zone === '4' ? '+' : ''}</strong>
    <p>Illustrative arrival window if ordered today.</p>
  `;
}
  function expanded(value) {
    const extra=$('more-customer-reviews'),toggle=$('show-all-reviews'),count=$('review-display-count');
    if(!extra||!toggle)return;
    const total = document.querySelectorAll('#all-review-list .all-review').length;
    const visible = total - extra.querySelectorAll('.all-review').length;
    extra.hidden=!value;toggle.setAttribute('aria-expanded',String(value));toggle.textContent=value?'Show fewer reviews':`Show all ${total} reviews`;if(count)count.textContent=value?`Showing all ${total} reviews`:`Showing ${visible} of ${total} reviews`;
  }
  function revealReview() {
    let id;try{id=decodeURIComponent(location.hash.slice(1));}catch(_){return;}
    const target=$(id),extra=$('more-customer-reviews');if(target&&extra?.contains(target)){expanded(true);target.scrollIntoView({block:'start'});}
  }
  let imageTrigger;
  document.addEventListener('change',e=>{if(e.target.matches('[data-ft-delivery-country]'))delivery(e.target);});
  document.addEventListener('click',e=>{
    const open=e.target.closest('[data-open-details]');if(open){const d=$(open.dataset.openDetails);if(d)d.open=true;}
    const close=e.target.closest('.ft-reference [data-action="close-dialog"]');if(close)close.closest('dialog')?.close();
    const compare=e.target.closest('[data-compare-rack]');if(compare){const table=document.querySelector('.comparison-table');if(table)table.dataset.mobileCompare=compare.dataset.compareRack;document.querySelectorAll('[data-compare-rack]').forEach(b=>b.setAttribute('aria-pressed',String(b===compare)));const status=$('mobile-comparison-status');if(status)status.textContent=`Comparing the Compact Rack with the ${compare.dataset.compareRack==='standard'?'Standard Power Rack':'Half Rack'}.`;}
    const toggle=e.target.closest('#show-all-reviews');if(toggle){const extra=$('more-customer-reviews');const next=extra.hidden;expanded(next);const target=next?extra.querySelector('.all-review'):$('customer-reviews');target?.focus({preventScroll:true});target?.scrollIntoView({block:'start',behavior:'smooth'});}
    const video=e.target.closest('[data-video-key]');if(video){const videos={overview:{id:'euiZ2_51YiM',title:'Functional Trainer walkthrough'}};const v=videos[video.dataset.videoKey],dialog=$('review-video-dialog');if(v&&dialog){$('review-video-title').textContent=v.title;$('review-video-external').href='https://www.youtube.com/watch?v='+v.id+'&t=1s';const iframe=document.createElement('iframe');iframe.src='https://www.youtube-nocookie.com/embed/'+v.id+'?autoplay=1&rel=0&start=1';iframe.title=v.title;iframe.allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';iframe.referrerPolicy='strict-origin-when-cross-origin';iframe.allowFullscreen=true;$('review-video-player').replaceChildren(iframe);dialog.showModal();}}
    const enlarge=e.target.closest('[data-enlarge]');if(enlarge){const dialog=$('ssr-image-dialog');if(dialog){imageTrigger=enlarge;const source=enlarge.querySelector('img');$('ssr-zoom-image').src=source.currentSrc||source.src;$('ssr-zoom-image').alt=source.alt;$('ssr-image-caption').textContent=source.alt;dialog.querySelector('.ssr-zoom-scroll').classList.remove('is-zoomed');$('ssr-zoom').textContent='Zoom in';$('ssr-zoom').setAttribute('aria-pressed','false');dialog.showModal();}}
    if(e.target.closest('#ssr-zoom')){const on=$('ssr-image-dialog').querySelector('.ssr-zoom-scroll').classList.toggle('is-zoomed');$('ssr-zoom').textContent=on?'Fit to screen':'Zoom in';$('ssr-zoom').setAttribute('aria-pressed',String(on));}
    if(e.target.closest('#ssr-close'))$('ssr-image-dialog').close();
    if(e.target.matches('.ft-reference dialog')){const r=e.target.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)e.target.close();}
  });
  document.addEventListener('close',e=>{if(e.target.id==='review-video-dialog')$('review-video-player')?.replaceChildren();if(e.target.id==='ssr-image-dialog')imageTrigger?.focus();},true);
  window.addEventListener('hashchange',revealReview);
  revealReview();
})();
